import styled from "styled-components";

export const RegistrationTicketTreeWrapper = styled.div``;
